import { useCurrentOrg } from './useCurrentOrg';

/**
 * @deprecated prefer useCurrentOrg().id
 */
export function useCurrentTeamId() {
  return useCurrentOrg().id;
}
